import React from 'react';
import { Check, Edit3, Trash2, X } from 'lucide-react';

function PathwayHistoryDrawer({
  isOpen,
  savedPathways,
  currentSavedPathwayId,
  editingPathwayId,
  editingPathwayTitle,
  onClose,
  onLoadPathway,
  onStartRenaming,
  onEditingTitleChange,
  onCancelRenaming,
  onRenamePathway,
  onDeletePathway
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="pathway-history-overlay" role="presentation" onClick={onClose}>
      <aside
        className="card pathway-history-drawer schema-scroll"
        aria-label="Saved pathways"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="chat-history-header">
          <div className="section-label">Saved Pathways</div>
          <div className="pathway-history-actions">
            <button type="button" className="icon-btn" onClick={onClose} aria-label="Close saved pathways">
              <X size={14} />
            </button>
          </div>
        </div>
        <div className="saved-pathway-list">
          {savedPathways.length === 0 && (
            <p className="assistant-info">No saved pathways yet.</p>
          )}
          {savedPathways.map((savedPathway) => (
            <div
              key={savedPathway.id}
              className={`saved-pathway-row ${currentSavedPathwayId === savedPathway.id ? 'active' : ''} ${editingPathwayId === savedPathway.id ? 'editing' : ''}`}
            >
              {editingPathwayId === savedPathway.id ? (
                <div className="saved-pathway-edit">
                  <input
                    value={editingPathwayTitle}
                    onChange={(event) => onEditingTitleChange(event.target.value)}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter') onRenamePathway(savedPathway.id);
                      if (event.key === 'Escape') onCancelRenaming();
                    }}
                    autoFocus
                  />
                  <button type="button" className="icon-btn" onClick={() => onRenamePathway(savedPathway.id)} aria-label="Save pathway name">
                    <Check size={14} />
                  </button>
                </div>
              ) : (
                <>
                  <button type="button" onClick={() => onLoadPathway(savedPathway)}>
                    <span>{savedPathway.title}</span>
                    <small>{savedPathway.updatedAt ? new Date(savedPathway.updatedAt).toLocaleDateString('en-GB') : 'Saved pathway'}</small>
                  </button>
                  <div className="saved-pathway-actions">
                    <button
                      type="button"
                      className="icon-btn"
                      onClick={() => onStartRenaming(savedPathway)}
                      aria-label={`Rename ${savedPathway.title}`}
                    >
                      <Edit3 size={13} />
                    </button>
                    <button
                      type="button"
                      className="icon-btn"
                      onClick={() => onDeletePathway(savedPathway.id)}
                      aria-label={`Delete ${savedPathway.title}`}
                    >
                      <Trash2 size={14} />
                    </button>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </aside>
    </div>
  );
}

export default PathwayHistoryDrawer;
